import classNames from 'clsx';
import PropTypes from 'prop-types';
import PillButton from './PillButton';
import css from './pill-button.module.scss';

const InkButton = ({ className = undefined, ...otherProps }) => (
  <PillButton className={classNames(className, css.ink)} {...otherProps} />
);

InkButton.propTypes = {
  className: PropTypes.string,
};

export default InkButton;
